import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class InventoryPartner extends BaseAPIModel {
    static getItemUrl(...args) {
        return this.listUrl(...args);
    }
    static list(item) {
        return this.fromJSON(item);
    }

    static listUrl({ organizationId, partnerId }) {
        return `/ticket/organizations/${organizationId}/partners/${partnerId}/stats-partner`;
    }
}
